export default __webpack_public_path__ + "static/piedao-be004fe4cf15a23efe00850117bb8246.jpg";